import { ISkuPackage } from '../util/interfaces/ecommerce';
import { getUnauthenticated } from './utility/Requests.default';

export const billingUrl = 'ecommerce_/api';

export async function getSkuPackagesForUsBillingEntity(portalDomain: string) {
    return await getUnauthenticated<ISkuPackage[]>(`${portalDomain}/${billingUrl}/sku-package-prices?countrycode=US`);
}
